export default "__VITE_ASSET__9f7d4749__"